<script>
    /* Imports */

    /* Props */
    // Název daného formulářového políčka
    export let labelTitle = "Název políčka";

    export let placeholder = "Zadejte hodnotu";

    export let id = "id-policka";
    
    export let required = false;
    
    export let type = "text";
    
    export let value = "";

    /* Vlastnosti rezervačního formuláře */

    /* Funkce rezervačního formuláře */

</script>

<div 
    class="form-field " id={`formularove-policko-${id}`}
    >
    <label 
        for={id}
        >
        {labelTitle}
    </label>
    {#if type === "text"}
        <input 
            type="text"
            {placeholder} 
            id="formularove-policko-{id}" 
            name={id} 
            {required} 
            bind:value={value}
        />
    {:else if type === "textarea"}
        <textarea 
            id="formularove-policko-{id}" 
            name={id} 
            {required} 
            {placeholder}  
            bind:value={value} />
    {:else if type === "number"}
        <input 
            type="number"
            {placeholder} 
            id="formularove-policko-{id}" 
            name={id} 
            {required} 
            bind:value={value}
        />
    {:else if type === "email"}
        <input 
            type="email"
            {placeholder} 
            id="formularove-policko-{id}" 
            name={id} 
            {required} 
            bind:value={value}
        />
    {:else if type === "checkbox"}
        <input 
            type="checkbox"
            {placeholder} 
            id="formularove-policko-{id}" 
            name={id} 
            {required} 
            bind:value={value}
        />
    {:else}
        <input 
            type="text"
            {placeholder} 
            id="formularove-policko-{id}" 
            name={id} 
            {required} 
            bind:value={value}
        />
    {/if}
</div>

<style>
    div.form-field 
    {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        width: 100%;
    }

    div.form-field > * 
    {
        width: 100%;
    }

    div.form-field > input {
        border-radius: 24px;
        padding: 8px 20px;
    }
</style>